module.exports = {
  messages: {
    CN: {
      'areaManagement.confirmPrompt': '确定要设为默认吗？',
      'areaManagement.setDefault': '设为默认',
      'areaManagement.default': '默认',
      'areaManagement.area': '区域',
      'areaManagement.city': '行政单位'
    },
    JP: {
      'areaManagement.confirmPrompt': '既定として設定しますか？',
      'areaManagement.setDefault': '既定に設定',
      'areaManagement.default': '既定',
      'areaManagement.area': 'エリア',
      'areaManagement.city': 'エリア'
    }
  }
};